import React, { useContext, useEffect, useState } from 'react'
import { sidebarContext } from '../../App'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import { FaBars, FaBed, FaBuilding, FaEnvelopeOpenText, FaHandHoldingHeart, FaHome, FaHospitalUser, FaSignOutAlt, FaUserCircle, FaUsers } from 'react-icons/fa'

export default function AdminHeader() {

  const navigate = useNavigate()
  const [user, setUser] = useState({})
  const { hs } = useContext(sidebarContext)
  const token = localStorage.getItem(['token'])
  const [menuOpen, setMenuOpen] = useState(false)

  const fetchUser = async() => {
    try{
      const res = await axios.get(`${config.baseurl}get_login_user/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('Logged-in User:', res.data)

      if(res.status === 200){
        setUser(res.data.data || {})
      }else{
        toast.error('Failed to fetch data')
      }
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create branch'

      toast.error(message)
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('token')
    toast.success('Logged out successfully')
    setTimeout(() => {

    }, 300)
  }

  useEffect(() => {
    fetchUser()
  },[token])

  const navigationItems = [
    {
      path:'/admin/admin_dashboard',
      label:'Admin Dashboash',
      icon:<FaHome/>,
      index:0
    },
    {
      path:'/admin/staffs',
      label:'Staffs',
      icon:<FaUsers/>,
      index:1
    },
    {
      path:'/admin/departments',
      label:'Departments',
      icon:<FaBuilding/>,
      index:2
    },
    {
      path:'/admin/new_admissions',
      label:'New Admision',
      icon:<FaHospitalUser/>,
      index:3
    },
    {
      path:'/admin/donation_enquiries',
      label:'Donation Enquiries',
      icon:<FaEnvelopeOpenText/>,
      index:4
    },
    {
      path:'/',
      label:'Logout',
      icon:<FaSignOutAlt/>,
      index:5
    },
  ]
  
  return (
    <div>

      {/*SIDEBAR*/}
      <aside className={`fixed  top-12 left-0 h-[calc(100vh-48px)] w-64 max-w-[80vw] z-40 bg-[#191c24] text-white  shadow-xl ${menuOpen ? 'translate-x-0' : '5xl:-translate-x-full'} 5xl:block`}>
        <div className="flex flex-col h-full">
          <div className="px-5 py-5 border-b border-slate-200">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full overflow-hidden bg-slate-200 flex items-center justify-center">
                <img
                  src={user?.image|| require('../../images/user.png')}
                  alt="User"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="min-w-0">
                <p className="text-xs text-gray-400 mb-1">
                  Welcome
                </p>

                <h3 className="text-sm font-semibold text-white truncate">
                  {user?.username || 'Admin'}
                </h3>
              </div>
            </div>

            <div className="mt-4">
              <p className="text-sm font-medium text-white truncate">
                {user?.first_name || ''}{' '}
                {user?.last_name || ''}
              </p>

              <p className="text-xs text-gray-400 mt-1 truncate">
                {user?.email || 'No email available'}
              </p>
            </div>
          </div>

          <div className="flex-1 px-3 py-5 overflow-y-auto">
            <nav className="space-y-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMenuOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-white
                    no-underline text-sm font-semibold  transition-all duration-200
                    ${
                      hs === item.index
                        ? 'bg-[#191c24] shadow-sm'
                        : 'hover:bg-[#191c24]/80'
                    }
                  `}
                >
                  <span className="text-lg">{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </aside>

      {/*HEADER*/}
      <header className=" bg-[#191c24] flex items-center justify-between  px-4 md:px-6 py-3 shadow-md h-[60px] fixed top-0 left-0 right-0 z-50">

        {/* Brand*/}
        <div className="flex items-center gap-3 min-w-0">
          <img
            src={require('../../images/Logo.jpg')}
            alt="Aurevia Charitable Trust Logo"
            className="w-10 h-10 rounded-full object-cover flex-shrink-0"
          />

          <div className="min-w-0">
            <h2 className="text-white text-xl 5xl:text-lg font-bold font-serif truncate">
              Aurevia Charitable Trust
            </h2>

            <p className="hidden md:block text-[10px] text-gray-400">
              Admin Dashboard
            </p>
          </div>
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-3">

          {/* User name - desktop */}
          <div className="hidden md:flex items-center gap-2 text-white">
            <FaUserCircle className="text-xl text-gray-300" />
            <span className="text-sm font-medium">
              {user?.username || 'Admin'}
            </span>
          </div>

          {/* Mobile / Small Screen Logout */}
          <button
            onClick={() => navigate('/')}
            className=" block 5xl:hidden items-center gap-2 px-3 py-2 rounded-md text-white text-sm font-medium hover:bg-red-500/20 hover:text-red-300 transition-all duration-200"
          >
            <FaSignOutAlt />
            <span className="block 5xl:hidden">
              Logout
            </span>
          </button>

          {/* Sidebar Toggle */}
          <button
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
            className="hidden 5xl:block items-center justify-center text-white p-2 rounded-md hover:bg-slate-200"
            aria-label="Toggle Sidebar"
            aria-expanded={menuOpen}
          >
            <FaBars size={20} />
          </button>
        </div>
      </header>

      {/*MOBILE SIDEBAR OVERLAY*/}
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          className="fixed inset-0 bg-black/50 z-30 5xl:block"
        />
      )}
    </div>
  )
}
